import SlimSelect from 'slim-select';
import './../../css/slimselect.min.css';
if (document.querySelector('#lang_choice_1')) {
	new SlimSelect({
		select: '#lang_choice_1',
		showSearch: false,
	});
}
